export const getCurrencySymbol = (code: string): string => {
  const symbols: Record<string, string> = {
    USD: 'US$',
    KRW: '원',
  };

  return symbols[code] || code;
};
